import { render, staticRenderFns } from "./KanbanCard.vue?vue&type=template&id=29d3a82f&scoped=true"
import script from "./KanbanCard.vue?vue&type=script&lang=ts"
export * from "./KanbanCard.vue?vue&type=script&lang=ts"
import style0 from "./KanbanCard.vue?vue&type=style&index=0&id=29d3a82f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d3a82f",
  null
  
)

export default component.exports